import React from 'react';
import '../shrineInformation/information-part/shrineInformationPartStyle.scss';
import './PilgrimageLetterStyle.scss';
import haramImage from '../../assets/images/haramImage.jpg'
import BackComponent from "../BackComponent/BackComponent.tsx";

function PilgrimageLetter() {
    return (

        <div className='information-section'>
            <BackComponent/>
            {/*<div className='pilgrimageLetter-img '>*/}
            {/*    /!*<img className='col-11 imgPil' src={haramImage}  alt='حضرت جعفر بن موسی الکاظم' />*!/*/}
            {/*</div>*/}
            <div className='letter-container col-11 p-3'>
                <span>بِسْمِ ٱللَّٰهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ</span>
                <p>
                    السَّلامُ عَلَیکَ اَیُّهَا السَّیِّدُ الزَّکِیُّ، اَلطّاهِرُ الوَلِیُّ، وَالدّاعِی الحَفِیُّ؛
                    اَشهَدُ اَنَّکَ قُلتَ حَقّاً، حَقّاً، وَنَطَقتَ حَقّاً وَصِدقاً، وَدَعوتَ اِلی مَولایَ وَمَولاکَ،
                    عَلانِیَةً وَسِرًّا، فازَ مُتَّبِعُکَ، وَنَجا مُصَدِّقُکَ، وَخابَ وَخَسِرَ مُکَذِّبُکَ،
                    وَالمُتَخَلِّفُ عَنکَ، اَشهَد لی بِهذهِ الشَّهادَةِ، لِاَکونَ مَنَ الفائِزینَ بِمَعرِفَتِکَ
                    وَطاعَتِکَ، وَتَصدیقِکَ وَاتِّباعَکَ، وَالسَّلامُ عَلَیکَ یا سَیِّدی وَابنَ سَیِّدی. اَنتَ بابُ
                    اللهِ المُؤتی مَنهُ، وَالمَأخوذُ عَنهُ، اَتَیتُکَ زائِراً، وَحاجاتی لَکَ مُستَودِعةً، وَها اَنَا ذا
                    اَستَودِعُکَ دینی وَاَمانَتی، وَخَواتیمَ عَمَلی، وَجَوامِعَ اَمَلی اِلی مُنتَهی اَجَلی، وَالسَّلامُ
                    عَلَیکَ وَ رَحمَةُ اللهِ وَبَرَکاتُه.
                </p>

                <p>
                    سلام بر تو ای آقای پاک و پاکیزه و سرور من و ای دعوت کننده (به حق) به مهربانی، گواهی دهم که تو حق
                    گفتی و به حق و راستی سخن کردی و (مردم را) آشکارا و نهان بسوی مولای من و مولای خودت دعوت فرمودی
                    رستگار شد پیرو تو و نجات یافت تصدیق کننده ات و نومید و زیانکار شد تکذیب کننده ات و آن کس که با تو
                    مخالفت کرد گواه باش برای من این گواهی را تا من بوسیله معرفت و اطاعت تو و تصدیق و پیروی کردنت از زمره
                    رستگاران باشم و سلام بر تو ای آقای من و ای فرزند آقای من توئی درگاه خدا که از آن درآیند و (معالم دین
                    را) از آن بگیرند آمده ام به درگاهت برای زیارت و حاجتهای خود را به تو سپرده ام و من اکنون به تو می
                    سپارم دینم و امانتم و سرانجام کارهایم و همه آرزوهایم را تا پایان عمرم و بر تو باد سلام و رحمت خدا و
                    برکاتش
                </p>
            </div>
        </div>
    )
}

export default PilgrimageLetter;
